import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// A small panel anchored under the control that opened it.
//
// A sheet sliding up from the bottom is right for the tiles, which sit at the
// bottom already. It is wrong for a corner icon: the panel arrives at the far
// end of the screen from the tap, the link between the two is lost, and on a
// short screen it can open where it cannot be seen.
//
// So anything triggered from the top bar gets one of these instead, dropping
// from the button with a small tail pointing back at it.
const Menu = ({ align = 'right', onClose, children, label }) => {
  const ref = useRef(null);

  useEffect(() => {
    // Anywhere outside dismisses, which is what a menu should do. Deferred to
    // the next frame so the click that opened it does not immediately close it.
    const onClick = (e) => { if (!ref.current?.contains(e.target)) onClose(); };
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };

    const id = requestAnimationFrame(() => document.addEventListener('click', onClick));
    document.addEventListener('keydown', onKey);

    return () => {
      cancelAnimationFrame(id);
      document.removeEventListener('click', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div
      className={'menu' + (align === 'left' ? ' menu--left' : '')}
      role="menu"
      aria-label={label}
      ref={ref}
    >
      {children}
    </div>
  );
};

Menu.propTypes = {
  align:    PropTypes.oneOf(['left', 'right']),
  onClose:  PropTypes.func.isRequired,
  children: PropTypes.node,
  label:    PropTypes.string,
};

export default Menu;
